import { render } from "./ProductSectionProductListComponent.vue?vue&type=template&id=0413d27a"
import script from "./ProductSectionProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/productSections/product/ProductSectionProductListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0413d27a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0413d27a', __exports__)) {
    api.reload('0413d27a', __exports__)
  }
  
  module.hot.accept("./ProductSectionProductListComponent.vue?vue&type=template&id=0413d27a", () => {
    api.rerender('0413d27a', render)
  })

}


export default __exports__